// Create this file at: packages/core/src/components/auth/VerificationGuard.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Box, CircularProgress, Typography } from '@mui/material';

const VerificationGuard = ({ children }) => {
  const { isAuthenticated, user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress size={40} />
        <Typography variant="body1" sx={{ mt: 2 }}>
          Checking verification status...
        </Typography>
      </Box>
    );
  }

  if (isAuthenticated && user?.verification_status === 'unverified') {
    // Allow access to the verification page itself
    if (location.pathname === '/verify-email') {
      return children;
    }
    // Redirect to verification page from any other protected route
    return <Navigate to="/verify-email" replace />;
  }

  return children;
};

VerificationGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default VerificationGuard;